module.exports = __webpack_public_path__ + "img/Truck1.3f99d907.jpg";